export default "__VITE_ASSET__BiKNylLV__"